import { render, staticRenderFns } from "./RestaurantCta.vue?vue&type=template&id=44d04c89&scoped=true&"
import script from "./RestaurantCta.vue?vue&type=script&lang=js&"
export * from "./RestaurantCta.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantCta.vue?vue&type=style&index=0&id=44d04c89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d04c89",
  null
  
)

export default component.exports